export default __webpack_public_path__ + "static/media/footerImg.82a0a031.jpg";